import PDFTemplate from './PDFTemplate';

export default PDFTemplate;
export { PDFTemplate };
